// extracted by mini-css-extract-plugin
export default {"tabIcon":"task_tabIcon__HmpDd"};